import React, { useEffect } from 'react';
import logo from '../../assets/logo.png';

/**
 * Hide the initial HTML loader (from index.html)
 */
export const hideInitialLoader = () => {
    const loader = document.getElementById('initial-loader');
    if (loader) {
        loader.style.opacity = '0';
        loader.style.transition = 'opacity 0.2s ease-out';
        setTimeout(() => loader.remove(), 200);
    }
};

/**
 * AppLoader - Écran de chargement initial de l'application
 * Affiché au démarrage pendant le chargement des données
 * Note: This component keeps the initial-loader visible (same design)
 */
const AppLoader = () => {
    // Don't hide the HTML loader while this component is mounted
    // The HTML loader has the same design, so we just return null
    // to avoid flickering between two identical loaders
    return null;
};

export default AppLoader;
